import React from 'react';
import { Typography } from '@crisellevaldez/speculo-ui';

interface StageContainerProps {
  title: string;
  description: string;
  children: React.ReactNode;
  variant?: 'default' | 'large';
}

export const StageContainer: React.FC<StageContainerProps> = ({
  title,
  description,
  children,
  variant = 'default',
}) => {
  const containerClasses =
    variant === 'large' ? 'max-w-[1400px] mx-auto px-4' : 'max-w-4xl mx-auto px-6 py-8';

  const titleClasses = variant === 'large' ? 'text-3xl' : 'text-2xl';

  return (
    <div className={containerClasses}>
      {/* Stage Introduction */}
      <div className={variant === 'large' ? 'text-center mb-8' : 'mb-8'}>
        <Typography variant="h1" className={`${titleClasses} font-bold mb-3`}>
          {title}
        </Typography>
        <p className="text-gray-600 dark:text-gray-400 leading-relaxed">{description}</p>
      </div>
      {children}
    </div>
  );
};
